import React from 'react';
import { Link } from '@reach/router';

export default () => (
  <section className='container-fluid p-md-0'>
        <style>
          {`
            .banner-heading-decorative {
              position: relative;
              padding: 20px 25px;
            }
            .banner-heading-decorative::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 50px;
              height: 50px;
              border-top: 3px solid #d4af37;
              border-left: 3px solid #d4af37;
              opacity: 0.8;
            }
            .banner-heading-decorative::after {
              content: '';
              position: absolute;
              bottom: 0;
              right: 0;
              width: 50px;
              height: 50px;
              border-bottom: 3px solid #d4af37;
              border-right: 3px solid #d4af37;
              opacity: 0.8;
            }
            @media (max-width: 768px) {
              .banner-heading-decorative {
                padding: 15px 20px;
              }
              .banner-heading-decorative::before {
                width: 40px;
                height: 40px;
                border-top: 3px solid #d4af37;
                border-left: 3px solid #d4af37;
              }
              .banner-heading-decorative::after {
                width: 40px;
                height: 40px;
                border-bottom: 3px solid #d4af37;
                border-right: 3px solid #d4af37;
              }
            }
            @media (max-width: 480px) {
              .banner-heading-decorative {
                padding: 12px 15px;
              }
              .banner-heading-decorative::before {
                width: 30px;
                height: 30px;
                border-top: 2px solid #d4af37;
                border-left: 2px solid #d4af37;
              }
              .banner-heading-decorative::after {
                width: 30px;
                height: 30px;
                border-bottom: 2px solid #d4af37;
                border-right: 2px solid #d4af37;
              }
            }
          `}
        </style>
        <div className='row'>

          <div className='col-md-6'>
            <img src='./img/bize-ulasin.jpeg' alt='imgbanner' className='w-100 border-radius'/>
          </div>
          <div className='col-md-6 centered'>
            <div>
              <div className="heading banner-heading-decorative">
                Siz İsteyin Biz Yapalım
              </div>
              <p>
                İhtiyacınız olan tüm çözümler için bize ulaşın. Hangrup olarak taleplerinizi en kısa sürede  
                <span className='br'></span>analiz ediyor, size özel en doğru çözümü sunuyoruz.
                <span className='br'></span>Siz isteyin, biz tüm süreci profesyonelce yönetelim.
              </p>
              <Link className='btn' to="/contact">
                <span className="shine"></span>
                <span>Teklif Al</span>
              </Link>
            </div>
          </div>
          
        </div>
    </section>
);
